import {useListView} from '../../core/ListViewProvider'
import {SuppliersListToolbar} from './SupplierListToolbar'
import {SuppliersListGrouping} from './SuppliersListGrouping'
import {SuppliersListSearchComponent} from './SuppliersListSearchComponent'

const SuppliersListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <SuppliersListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <SuppliersListGrouping /> : <SuppliersListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {SuppliersListHeader}
